import React from "react";
import OnboardingCelebration from "static/images/OnboardingCelebration.svg";

export const CurrentYearIncorporateBanner = () => {
  return (
    <div className="t-pl-4 t-pr-3 t-py-3 t-border t-border-solid t-border-purple-20 t-bg-purple-0 t-rounded-lg t-mb-4">
      <div className="t-text-subtext-sm t-text-text-100 t-flex t-items-center t-gap-1">
        This Year’s Free. Billing Begins January 1st
        <img
          src={OnboardingCelebration}
          alt="OnboardingCelebration"
          className="t-size-3"
        />
      </div>
      <div className="t-text-body-sm t-text-text-30">
        As your incorporation is this year, billing begins on January 1st at
        $300 per year. The current year is free!
      </div>
    </div>
  );
};
